import {css} from 'styled-components';

export const reset = css`
    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

    a {
        text-decoration: none;
        color: inherit;
        cursor: pointer;
    }

    button {
        background-color: transparent;
        color: inherit;
        border-width: 0;
        padding: 0;
        cursor: pointer;
    }

    figure {
        margin: 0;
    }

    input::-moz-focus-inner {
        border: 0;
        padding: 0;
        margin: 0;
    }

    ul,
    ol,
    dd {
        margin: 0;
        padding: 0;
        list-style: none;
    }

    p {
        margin: 0;
    }

    cite {
        font-style: normal;
    }

    fieldset {
        border-width: 0;
        padding: 0;
        margin: 0;
    }

    br {
        margin-bottom: 4px;
    }
    .simmer_down{
        color: #808080!important;
    }
`;
